import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			className: "frontCircle",
			x: 2,
			y: 2,
			width: 32,
			height: 32,
			rx: 16,
			fill: "#7A501F"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon",
			d: "M17.9998 15.3331V17.9998M17.9998 20.6665H18.0064M16.8598 11.9065L11.2131 21.3331C11.0967 21.5348 11.0351 21.7633 11.0344 21.9962C11.0338 22.229 11.0941 22.4579 11.2094 22.6602C11.3247 22.8624 11.4909 23.031 11.6916 23.149C11.8922 23.2671 12.1203 23.3306 12.3531 23.3331H23.6464C23.8792 23.3306 24.1073 23.2671 24.308 23.149C24.5086 23.031 24.6749 22.8624 24.7902 22.6602C24.9054 22.4579 24.9658 22.229 24.9651 21.9962C24.9645 21.7633 24.9029 21.5348 24.7864 21.3331L19.1398 11.9065C19.0209 11.7105 18.8536 11.5486 18.6539 11.4361C18.4542 11.3237 18.2289 11.2646 17.9998 11.2646C17.7706 11.2646 17.5453 11.3237 17.3456 11.4361C17.146 11.5486 16.9786 11.7105 16.8598 11.9065Z",
			stroke: "#E0B685",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "bgCircle",
			x: 2,
			y: 2,
			width: 32,
			height: 32,
			rx: 16,
			stroke: "#452D11",
			strokeWidth: 4
		})
	]
});
export default SvgWarning;
